export const formatLongString = (
    x: string | null | undefined,
    maxLength = 40,
) => {
    if (!x) {
        return '';
    }
    return x.length > maxLength - 1 ? x.slice(0, maxLength) + '...' : x;
};
